import { render, staticRenderFns } from "./NosePunching.vue?vue&type=template&id=5f4a5e63&scoped=true&"
import script from "./NosePunching.vue?vue&type=script&lang=js&"
export * from "./NosePunching.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f4a5e63",
  null
  
)

export default component.exports